import classNames from 'classnames';
import { FC, HTMLAttributes } from 'react';

import TextBase, { TextProps } from './TextBase';

import style from './gradient-text.module.css';

// eslint-disable-next-line @stylistic/max-len
interface Props extends HTMLAttributes<HTMLParagraphElement>, Omit<TextProps, 'as' | 'fontColor' | 'fontSize' | 'fontWeight'> {
  as?: Extract<TextProps['as'], 'h1' | 'h2'>;
  fontSize?: Extract<TextProps['fontSize'], 36 | 48>;
}

// Component Definition
const GradientText: FC<Props> = ({
  as = 'h1',
  className,
  fontSize = 36,
  ...props
}) => {
  return (
    <TextBase
      {...props}
      as={as}
      className={classNames(
        style.gradientText,
        { [style.gradient48]: fontSize === 48 },
        className,
      )}
      fontColor="black"
      fontSize={fontSize}
      fontWeight={700}
      uppercase={false}
    />
  );
};

export default GradientText;
